<template>
  <bk-view class="view-shopItem" @click="shopItemClick">
    <bk-view class="view-image">
      <bk-image class="img-cover" :src="item.showCoverImg"></bk-image>
      <bk-view v-if="item.hasFavorite" class="view-favorite select"></bk-view>
    </bk-view>
    <bk-view class="view-text">
      <bk-view class="view-name overflowText">{{ item.name }}</bk-view>
      <bk-view class="view-address">
        <bk-icon icon="icon-dizhi"></bk-icon>
        <span>{{ item.address }}</span>
      </bk-view>
      <!-- 评分 -->
      <bk-view class="view-star" v-if="avgScoreFixed != 0">
        <bk-view class="view-starValue">
          <bk-view class="view-starBc" :style="{ width: `${starWidth}px` }"></bk-view>
        </bk-view>
        <bk-view class="view-starNum">{{ avgScoreFixed }}</bk-view>
      </bk-view>
      <!-- 无评分 -->
      <bk-view class="view-starNum" v-else>
        <bk-lang code="home_showItem_noRate"></bk-lang>
      </bk-view>
      <bk-view class="view-distanceText">
        {{ item.distanceText }}
      </bk-view>
    </bk-view>
  </bk-view>
</template>

<script>
	export default {
		name: 'shopItem',
		props: {
			item: Object,
		},
		computed: {
			starWidth () {
				// 0返回0
				if (!this.item.commentStatisticVo.avgScore) {
					return 0;
				}
				// 其他返回百分比
				let star = Number(this.item.commentStatisticVo.avgScore);

				let n = 24 * Math.floor(star);

				n += 16 * (star - Math.floor(star));

				bkLog.log('N:', n);

				return n;
			},
		},
		data () {
			return {
				avgScoreFixed: 0,
			};
		},
		mounted () {
			// console.log('item:0', this.$bk_copy(this.item));
			if (this.item?.commentStatisticVo?.avgScore) {
				this.avgScoreFixed = this.item.commentStatisticVo.avgScore.toFixed(1);
			} else {
				this.avgScoreFixed = 0;
			}
		},
		methods: {
			shopItemClick () {
				const { canReserve } = this.item;
				// if( !canReserve ) {
				// 	this.$bk_message.warning({ langCode: 'home_reserve_error' });
				// 	return;
				// }

				if (typeof window.showReserve == 'function') {
					window.showReserve({
						resShopInfo: this.item,
						resItemInfo: undefined,
					});
				}
			},
		},
	};
</script>

<style scoped lang="less">
  .view-shopItem {
    position: relative;
    background: @color-bc-def;
    box-shadow: 0px 3px 16px 0px rgba(20, 56, 149, 0.06);
    border-radius: 10px;
    padding: 12px 12px 12px 104px;
    min-height: 104px;
    margin-bottom: 12px;

    > .view-image {
      .marginCenterAuto(auto, auto, auto, 12px);
      width: 80px;
      height: 80px;

      > .bk-image {
        border-radius: 6px;
        overflow: hidden;
        width: 100%;
        height: 100%;
      }

      > .view-favorite {
        .marginCenterAuto(-1px, -1px, auto, auto);
        width: 20px;
        height: 20px;
        border-radius: 0 0 0 4px;

        .configImgUrlBc('Def_Icon_Favorite_N.png', @color-bc-def, center / 14px no-repeat);

        &.select {
          .configImgUrlBc('Def_Icon_Favorite_S.png', @color-bc-def, center / 12px no-repeat);
        }
      }
    }

    > .view-text {
      > .view-name {
        line-height: 32px;
        .fontBloder();
        padding-right: 44px;
      }
      > .view-address {
        font-size: @font-tip;
        color: @color-text-999;
        margin-top: 5px;
        padding: 0 12px 0 0;
        >.bk-icon{
          color: var(--color-main-auxiliary);
        }
      }
      > .view-starNum {
        display: inline-block;
        vertical-align: top;
        line-height: 20px;
        color: @color-text-999;
        font-size: @font-tip;
        margin-left: 4px;
      }
      > .view-star {
        margin-top: 4px;
        .fontBloder();
        .configImgUrlBc('Def_Image_Star_N.png', @color-bc-def, left center / 112px 16px no-repeat);
        height: 20px;

        > .view-starValue {
          display: inline-block;
          width: 112px;
          margin-right: 8px;

          > .view-starBc {
            height: 20px;
            .configImgUrlBc('Def_Image_Star_S.png', transparent, left center / 112px 16px no-repeat);
          }
        }
        > .view-starNum {
          display: inline-block;
          vertical-align: top;
          line-height: 20px;
          color: @color-text-999;
        }

        //> .view-starItem {
        //  display: inline-block;
        //  vertical-align: top;
        //  width: 16px;
        //  height: 20px;
        //  .configImgUrlBc('Def_Icon_Star.png', @color-bc-def, center / 16px no-repeat);
        //  margin-right: 8px;
        //}
      }

      > .view-distanceText {
        .marginCenterAuto(0, 0, auto, auto);
        line-height: 32px;
        color: @color-text-999;
        font-size: @font-tip;
        .fontBloder();
      }
    }
  }
</style>
